import React, {useState} from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
export function FormPartDate(props) {
	let {formPart, saveFunction, lang, register, showErrors} = props;

	const [startDate, setStartDate] = useState(null);
	return (
		<div  className={'form-group'}>
			<label className={' '} htmlFor={'input-'+formPart.id}>{formPart.label}</label>
			<DatePicker
				selected={startDate}
				onChange={(date) => {
					setStartDate(date)
					saveFunction(date, formPart.id, 'date')
				}}
				ref={register({required: formPart.required})}
				dateFormat="P"
				locale={lang}
				className={formPart.required ? 'form-control requiredField ': 'form-control' }
				name={'input-'+formPart.id}
				required={formPart.required}
				placeholder={formPart.placeholder}
				minDate={new Date(1900,1,1)}
				maxDate={new Date(2100,1,1)}
			/>
			{
				formPart.required && showErrors && !startDate && (<span className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', lang)}</span>)
			}
		</div>
	);
}
